var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NicknameTextField',{attrs:{"isHiddenRequiredSign":false},model:{value:(_vm.nickname),callback:function ($$v) {_vm.nickname=$$v},expression:"nickname"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }